export default ".color_bg {\n  background-color: #c57272 !important;\n}";